const trackedSortables = () => {
  if (Array.isArray(window.sortables) === false) {
    window.sortables = [];
  }

  return window.sortables;
};

const pruneStaleSortables = () => {
  window.sortables = trackedSortables().filter((sortable) => {
    if (sortable.el && sortable.el.isConnected) return true;

    if (sortable.destroy) sortable.destroy();
    return false;
  });
};

const ensureSortable = (container, options, metadata = {}) => {
  if (!container) return null;

  const existingSortable = Sortable.get(container);
  if (existingSortable) {
    Object.keys(options).forEach((key) => {
      existingSortable.option(key, options[key]);
    });
    Object.assign(existingSortable, metadata);
    return existingSortable;
  }

  pruneStaleSortables();

  const sortable = new Sortable(container, options);
  Object.assign(sortable, metadata);
  trackedSortables().push(sortable);

  return sortable;
};

export default ensureSortable;
